import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

import general from './general'
import user from './user'
import supporter from './supporter'
import jobs from './jobs'
import job from './job'
import client from './client'
import admin from './admin'


export default new Vuex.Store({
  modules: {
    general,
    user,
    jobs,
    job,
    client,
    admin,
    supporter,
  },
  // enable strict mode (adds overhead!)
  // for dev mode only
  strict: process.env.DEV,
});

